import React from 'react';
import { Card, CardHeader, CardContent, Grid } from '@material-ui/core';
import { Fer } from '../../utils/types';
import SimpleTextInfo from '../common/SimpleTextInfo';
import SimpleDateInfo from '../common/SimpleDateInfo';
import Player from '../highlights/Player';

export const FerDetails: React.FC<FerDetailsProps> = (props) => {
	const { ferId, channelId, startTime, endTime, gameId, available, endpoint } = props;

	return (
		<Grid container spacing={1}>
			<Grid item xs={12}>
				<Card>
					<CardHeader title='Fer details' />
					<CardContent>
						<Grid container spacing={2}>
							<Grid container item xs={12} md={9} spacing={3}>
								<Grid container item xs={12} lg={6} direction='column' spacing={1}>
									<SimpleTextInfo label='ID' value={ferId} to={`/games/${encodeURIComponent(gameId)}/fers/${encodeURIComponent(ferId)}`} />
									<SimpleTextInfo label='Game ID' value={gameId} to={`/games/${encodeURIComponent(gameId)}`} />
									<SimpleTextInfo label='Channel' value={channelId} to={`/channels/${encodeURIComponent(channelId)}`} />
									<SimpleDateInfo label='Start time' value={startTime} />
									{endTime && <SimpleDateInfo label='End time' value={endTime} />}
									{available && <SimpleTextInfo label='Available' value={`${available!.toString()}`} />}
									{endpoint && <SimpleTextInfo label='Video Link' value={`${endpoint}`} pathname={`${endpoint}`} target='_blank' />}
								</Grid>
							</Grid>
							<Grid container item xs={12} lg={12} direction='column' spacing={1}>
								{endpoint ? <Player url={endpoint} videoWidth='2048' videoHeight='576' /> : 'Video URL and Start Time could not be found'}
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};

type FerDetailsProps = Fer & { hidePeriodDetails?: boolean | null } & { refetchFerDetails: () => void };

export default FerDetails;
